export enum CommentSenderRoleEnum {
  Staff = 'staff',
  Family = 'family',
}